import styled from '@style'

const HeroSection = styled.section`
  z-index: 1;
  position: relative;
`

export { HeroSection }
